import React__default from 'react';
import { determineDataTestIdPrefix, getBaseProps, getAriaProps } from '../../../helpers/propHelpers.js';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '../Tooltip/Tooltip.js';

const Badge = (props) => {
    const findColor = () => {
        let color = 'Badge--slate';
        if (props.color) {
            color = `Badge--${props.color}`;
        }
        if (props.hollow) {
            color += '-hollow';
        }
        return color;
    };
    const color = findColor();
    const getBadgeClasses = () => {
        return classNames({
            Badge: true,
            [props.className]: props.className,
            [`Badge--v-${props.variant}`]: true,
            [`Badge--uppercase`]: props === null || props === void 0 ? void 0 : props.uppercase,
            [color]: true,
        });
    };
    const dataTestId = determineDataTestIdPrefix(props, 'badge');
    const baseProps = getBaseProps(props);
    const ariaProps = getAriaProps(props);
    const BadgeContent = () => {
        return (React__default.createElement("span", Object.assign({}, baseProps, ariaProps, { className: classNames(getBadgeClasses(), props === null || props === void 0 ? void 0 : props.className), "data-testid": `${dataTestId}`, title: props.tooltip ? undefined : props.title }),
            (props === null || props === void 0 ? void 0 : props.iconLeft) && (React__default.createElement(FontAwesomeIcon, { className: "Badge__iconLeft", icon: props.iconLeft.icon, "data-testid": `${dataTestId}-left-icon` })),
            (props === null || props === void 0 ? void 0 : props.text) || props.children,
            (props === null || props === void 0 ? void 0 : props.iconRight) && (React__default.createElement(FontAwesomeIcon, { className: "Badge__iconRight", icon: props.iconRight.icon, "data-testid": `${dataTestId}-right-icon` }))));
    };
    return (React__default.createElement(React__default.Fragment, null,
        props.badgeList === true && (React__default.createElement("div", Object.assign({}, ariaProps, { "data-testid": `${dataTestId}`, className: classNames(`BadgeList`, props === null || props === void 0 ? void 0 : props.className) }), props.children)),
        props.badgeList !== true && (React__default.createElement(React__default.Fragment, null,
            props.tooltip && (React__default.createElement(Tooltip, Object.assign({}, props.tooltip),
                React__default.createElement(BadgeContent, null))),
            !props.tooltip && React__default.createElement(BadgeContent, null)))));
};
Badge.defaultProps = {
    variant: 'default',
};

export { Badge, Badge as default };
//# sourceMappingURL=Badge.js.map
